// auth
export const SET_USER = 'SET_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGGED_IN_USER = 'LOGGED_IN_USER';
export const REFRESH_USER = 'REFRESH_USER';
export const SET_REFRESH_USER = 'SET_REFRESH_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const REGISTER_USER = 'REGISTER_USER';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const CHANGE_LOADING = 'CHANGE_LOADING';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const SET_SESSION_USER = 'SET_SESSION_USER';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

// theme
export const DARK_THEME = "DARK_THEME";
export const LIGHT_THEME = "LIGHT_THEME";

// Translation
export const SET_TRANLSLATION = "SET_TRANLSLATION";

// driver
export const GET_ALL_DRIVER = 'GET_ALL_DRIVER';
export const GET_ALL_DRIVER_ERROR = 'GET_ALL_DRIVER_ERROR';
export const GET_ALL_DRIVER_SUCCESS = 'GET_ALL_DRIVER_SUCCESS';
export const ADD_DRIVER = 'ADD_DRIVER';
export const ADD_DRIVER_ERROR = 'ADD_DRIVER_ERROR';
export const ADD_DRIVER_SUCCESS = 'ADD_DRIVER_SUCCESS';